import { render, staticRenderFns } from "./EmployeeAboutInfo.vue?vue&type=template&id=1145d27e"
import script from "./EmployeeAboutInfo.vue?vue&type=script&lang=js"
export * from "./EmployeeAboutInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports